import React, { ChangeEvent, useRef } from "react";
import { Container, Row, Image } from "react-bootstrap";
import { Input } from "./Input";
import { Setter } from "../Data/Types";
import { Button } from "./Button";
import { Trash } from "react-bootstrap-icons";

interface ImageUploaderProps {
    setFile: Setter<File | undefined>;
    preview?: string;
    setPreview: Setter<string | undefined>;
    children: string;
}

const ImageUploader = ({ children, setFile, preview, setPreview }: ImageUploaderProps) => {
    const inpRef = useRef<HTMLInputElement>(null);

    const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length === 1) {
            const f = e.target.files[0];
            setFile(f);
            const url = URL.createObjectURL(f);
            setPreview(url);
        }
        inpRef.current!.value = "";
        inpRef.current!.setAttribute("class", "d-none");
    };

    const removeImage = () => {
        setPreview(undefined);
        setFile(undefined);
    };

    return (
        <Container fluid className="p-0 w-100">
            <div>
                {!preview && (
                    <Button onClick={() => inpRef.current!.click()} className="w-100">
                        {children}
                    </Button>
                )}
                <Input
                    label="Choose Facility Images"
                    type="file"
                    onChange={handleFileChange}
                    accept="image/*"
                    ref={inpRef}
                    className="d-none"
                />

                <Row className="mt-3">
                    {preview && (
                        <div className="position-relative">
                            <Image src={preview} alt="preview" thumbnail />
                            <Trash
                                style={{ position: "absolute", top: "3%", right: "3%" }}
                                className="bg-white opacity-100 shadow"
                                onClick={removeImage}
                            />
                        </div>
                    )}
                </Row>
            </div>
        </Container>
    );
};

export default ImageUploader;
